import { useEffect, useRef, useState } from "react";

const CLIENT = process.env.REACT_APP_ADSENSE_CLIENT;
const SLOT = process.env.REACT_APP_ADSENSE_SLOT;

function loadScript() {
  if (document.querySelector('script[src*="adsbygoogle.js"]')) return;
  const s = document.createElement("script");
  s.async = true;
  s.crossOrigin = "anonymous";
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
  document.head.appendChild(s);
}

export function AdBanner() {
  const pushed = useRef(false);
  const insRef = useRef(null);
  const [unfilled, setUnfilled] = useState(false);

  useEffect(() => {
    if (!CLIENT || !SLOT || pushed.current) return;
    loadScript();
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); pushed.current = true; } catch { /* ad blocked */ }
  }, []);

  useEffect(() => {
    const el = insRef.current;
    if (!el) return;
    const check = () => setUnfilled(el.getAttribute("data-ad-status") === "unfilled");
    const obs = new MutationObserver(check);
    obs.observe(el, { attributes: true, attributeFilter: ["data-ad-status"] });
    check();
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    document.body.classList.toggle("no-ad", unfilled);
  }, [unfilled]);

  return (
    <div className={`ad-banner ${unfilled ? "ad-hidden" : ""}`} data-testid="ad-banner">
      {CLIENT && SLOT ? (
        <ins ref={insRef} className="adsbygoogle" style={{ display: "inline-block", width: 320, height: 50 }}
          data-ad-client={CLIENT} data-ad-slot={SLOT} data-testid="ad-slot" />
      ) : (
        <div className="ad-placeholder" data-testid="ad-placeholder"><span>Ad</span>Advertisement space</div>
      )}
    </div>
  );
}
